import axios, { AxiosRequestConfig, Method } from 'axios'
import md5 from 'md5'
import { Message, Loading } from 'd-element-ui'
import router from '@/router'
interface defaultConfig {
    loading: boolean
}
let loading: any = undefined
let loadingStack = 0
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        console.error('服务器请求失败，请稍后再试')
        return Promise.reject(error)
    }
)

const http = {
    request(method: Method, path: string, data: {}, configParmas: AxiosRequestConfig) {
        const defaultConfig: defaultConfig = {
            loading: false
        }
        data = data || {}
        const config = Object.assign(defaultConfig, configParmas)
        const defaultData = {
            userId: localStorage.getItem('userId') || undefined,
            ntwId: (router as any).history.current.params.ntwId || -1
        }
        config.data = Object.assign(defaultData, data)
        config.headers = {
            uid: localStorage.getItem('userId'),
            token: localStorage.getItem('token'),
            terminal: 1,
            notSign: 'notSign'
        }
        if (config.loading) {
            if (loadingStack > 0) {
                loadingStack++
            } else {
                loadingStack = 1
                loading = Loading.service({
                    lock: true,
                    text: '加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(255, 255, 255, 0.7)'
                })
            }
        }
        return axios
            .request({
                method: method,
                url: path,
                ...config
            })
            .then(res => {
                if (res.data.code === '1') {
                    return res.data
                } else if (res.data.code === '7') {
                    localStorage.clear()
                    router.push(`/${(router as any).history.current.params.ntwId || -1}/getToken?token=`)
                } else {
                    Message.error({
                        message: res.data.msg
                    })
                    return Promise.reject(res.data)
                }
            })
            .finally(() => {
                if (config.loading) {
                    loadingStack--
                    if (loadingStack === 0) {
                        loading.close()
                    }
                }
            })
    },
    // 默认的通用get和post
    post(path: string, data = {}, config = {}) {
        return this.request('post', path, data, config)
    },
    get(path: any, data = {}, config = {}) {
        return this.request('get', path, data, config)
    },
    getDataWithToken(data: { campId: string | null; version: number }) {
        const result: any = { ...data }
        result.timestamp = new Date().valueOf()
        result.campId = data.campId || localStorage.getItem('campId')
        result.uid = localStorage.getItem('uid')
        result.terminal = 1
        result.version = data.version || -1
        result.kick = true
        const array = []
        for (const key in result) {
            array.push(result[key])
        }

        array.push(localStorage.getItem('token'))
        array.sort()
        const str = array.join('')
        result.sign = md5(str)
        return result
    },
    paramsToString(params: { [x: string]: any }) {
        const paramsArray = []
        for (const name in params) {
            if (Object.prototype.hasOwnProperty.call(params, name)) {
                let str = ''
                if (params[name] !== null && params[name] !== undefined) {
                    str = JSON.stringify(params[name])
                }
                if (str.substring(0, 1) === '"' && str.substring(str.length - 1) === '"') {
                    str = str.substring(1, str.length - 1)
                }
                paramsArray.push(`${name}=${str}`)
            }
        }
        return paramsArray.join('&')
    }
}

export default http
